import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

// Publieke acceptatiepagina voor bedrijfs-uitnodigingen (Admin / Beheer / Kijken).
// Bestaand account → lidmaatschap wordt gekoppeld. Nieuw → naam + wachtwoord aanmaken.
export default function CompanyInviteAccept() {
  const { token } = useParams();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/companies/invite/${token}`)
      .then(({ data }) => {
        if (data.used) setError("Deze uitnodiging is al gebruikt.");
        else if (data.expired) setError("Deze uitnodiging is verlopen. Vraag een nieuwe aan.");
        else setInvite(data);
      })
      .catch(() => setError("Uitnodiging niet gevonden of ongeldig."));
  }, [token]);

  const accept = async () => {
    if (!name.trim()) { toast.error("Vul je naam in"); return; }
    if (password.length < 8) { toast.error("Wachtwoord moet minimaal 8 tekens zijn"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/companies/invite/accept", { token, name, password });
      setDone(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Accepteren mislukt");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F3F0] flex items-center justify-center px-6" data-testid="invite-accept-page">
      <div className="w-full max-w-md border border-[#F5F3F0]/15 p-8">
        <div className="chip text-[#4A4A4A]">JOH. BOXING / BEDRIJVEN</div>
        {error && (
          <div className="mt-8">
            <h1 className="font-display text-2xl uppercase" data-testid="invite-error">{error}</h1>
            <Link to="/" className="chip text-[#A3A3A3] hover:text-[#F5F3F0] mt-6 inline-block transition-colors" data-testid="invite-home">← NAAR JOHBOXING.COM</Link>
          </div>
        )}
        {!error && !invite && <div className="chip text-[#4A4A4A] mt-8" data-testid="invite-loading">UITNODIGING LADEN …</div>}
        {invite && !done && (
          <div className="mt-8" data-testid="invite-form">
            <h1 className="font-display text-2xl uppercase" data-testid="invite-title">{invite.company_name}</h1>
            <p className="text-sm text-[#A3A3A3] mt-3 leading-relaxed">
              Je bent uitgenodigd als <span className="text-[#D4A93A]">{invite.role === "admin" ? "Admin" : invite.role === "beheer" ? "Beheer" : "Kijken"}</span> voor <span data-testid="invite-email">{invite.email}</span>.
            </p>
            <div className="space-y-4 mt-8">
              <input value={name} onChange={(e) => setName(e.target.value)} placeholder="JE NAAM *" className="editorial-input dark w-full" data-testid="invite-name" />
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="KIES EEN WACHTWOORD (MIN. 8) *" className="editorial-input dark w-full" data-testid="invite-password" />
              <p className="text-xs text-[#4A4A4A] leading-relaxed">Heb je al een JOH-account met dit e-mailadres? Vul je naam in en kies een nieuw wachtwoord — je bestaande account wordt gekoppeld zodra je daarna inlogt.</p>
            </div>
            <button onClick={accept} disabled={busy} className="btn-light w-full justify-center mt-8 disabled:opacity-40" data-testid="invite-submit">{busy ? "…" : "UITNODIGING ACCEPTEREN"}</button>
          </div>
        )}
        {done && (
          <div className="mt-8" data-testid="invite-success">
            <h1 className="font-display text-2xl uppercase">TOEGANG GEACTIVEERD</h1>
            <p className="text-sm text-[#A3A3A3] mt-4 leading-relaxed">
              Je bent nu <span className="text-[#D4A93A]">{done.role === "admin" ? "Admin" : done.role === "beheer" ? "Beheer" : "Kijken"}</span> van {done.company_name}.
              De bedrijfsomgeving wordt binnenkort geopend — je ontvangt daar bericht over.
            </p>
            <Link to="/" className="chip text-[#A3A3A3] hover:text-[#F5F3F0] mt-8 inline-block transition-colors" data-testid="invite-done-home">← NAAR JOHBOXING.COM</Link>
          </div>
        )}
      </div>
    </div>
  );
}
